module.exports = __webpack_public_path__ + "img/icon_dim.0feb7bac.png";